'use client';

import { Typography } from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import Image from 'next/image';
import { useEffect } from 'react';
import { getCdnUrl } from '../../common/utils';
import {
  isMusinsaService,
  trackCouponGuideScreenViewMusinsa,
} from '../utils/campaignProposalMusinsaAnalytics';

const SHARE_LINK_IMAGE = getCdnUrl('images/coupon-guide/coupon_guide_1.png');
const DOWNLOAD_IMAGE = getCdnUrl('images/coupon-guide/coupon_guide_2.png');
const CONTRIBUTION_SHOP_IMAGE = getCdnUrl('images/coupon-guide/coupon_guide_3.png');
const CONTRIBUTION_LINK_IMAGE = getCdnUrl('images/coupon-guide/coupon_guide_4.png');

export const CouponGuidePageView = () => {
  const { service } = useDeviceInfo();

  useEffect(() => {
    if (!isMusinsaService(service)) return;
    trackCouponGuideScreenViewMusinsa();
  }, [service]);

  return (
    <div className="flex flex-1 flex-col bg-white px-[16px]!">
      <div className="pt-[24px]! pb-[12px]!">
        <Typography variant="body13pxReg" colorScheme="gray-700">
          콘텐츠 발행 시 구독자에게 쿠폰 적용 상품 페이지 링크를 공유하고, 쿠폰 다운로드 및 사용
          방법을 꼭 함께 안내해 주세요.
        </Typography>
      </div>

      <div className="pb-[72px]!">
        <section>
          <Typography variant="body14pxMed" colorScheme="black" className="block py-[12px]!">
            나의 쿠폰 적용 상품 페이지 링크 공유하기
          </Typography>
          <Image
            src={SHARE_LINK_IMAGE}
            alt="쿠폰 적용 상품 페이지 링크 공유 안내 이미지"
            width={1029}
            height={684}
            priority
            unoptimized
            className="w-full h-auto rounded bg-[#E0E0E0]"
          />
          <Typography variant="body13pxReg" colorScheme="gray-600" className="block py-[12px]!">
            쿠폰 캠페인 페이지 &gt; 브랜드 협업 제안 수락 탭 &gt; [적용상품 링크 복사] 버튼을
            누르거나, 쿠폰 적용 상품 페이지 &gt; [공유 링크 복사] 버튼을 통하여 생성할 수 있습니다.
          </Typography>
        </section>

        <section>
          <Typography variant="body14pxMed" colorScheme="black" className="block py-[12px]!">
            구독자에게 쿠폰 다운로드 위치 안내
          </Typography>
          <Image
            src={DOWNLOAD_IMAGE}
            alt="쿠폰 다운로드 위치 안내 이미지"
            width={1029}
            height={684}
            priority
            unoptimized
            className="w-full h-auto rounded bg-[#E0E0E0]"
          />
          <Typography variant="body13pxReg" colorScheme="gray-600" className="block py-[12px]!">
            쿠폰 적용 상품 페이지 &gt; [쿠폰 받기] 버튼을 통해 쿠폰을 다운로드할 수 있습니다. 쿠폰이
            모두 소진되면 발급이 중단되며, 사용 기간이 종료된 후에는 쿠폰을 발급받을 수 없습니다.
          </Typography>
        </section>

        <section className="pb-[12px]!">
          <Typography variant="body14pxMed" colorScheme="black" className="block py-[12px]!">
            큐레이터 쿠폰 기여 인정 기준
          </Typography>
          <Image
            src={CONTRIBUTION_SHOP_IMAGE}
            alt="큐레이션 샵 링크를 통한 쿠폰 기여 인정 기준 이미지"
            width={1029}
            height={660}
            priority
            unoptimized
            className="w-full h-auto rounded bg-[#E0E0E0]"
          />
          <Typography
            variant="body13pxReg"
            colorScheme="gray-600"
            className="block pt-[12px]! pb-[12px]!"
          >
            큐레이터가 공유한 [쿠폰 적용 상품 페이지] 또는 [큐레이션 샵 링크]로 접속해, 쿠폰 적용
            상품 페이지나 큐레이션 샵에 전시된 상품을 구매한 경우에만 기여가 인정됩니다.
          </Typography>
          <Image
            src={CONTRIBUTION_LINK_IMAGE}
            alt="개별 제휴 링크를 통한 쿠폰 기여 인정 기준 이미지"
            width={1029}
            height={660}
            priority
            unoptimized
            className="w-full h-auto rounded bg-[#E0E0E0]"
          />
          <Typography
            variant="body13pxReg"
            colorScheme="gray-600"
            className="block pt-[12px]! pb-[4px]!"
          >
            또는 쿠폰 적용이 가능한 상품의 [개별 제휴 링크]를 통해 구매한 경우에만 기여가
            인정됩니다.
          </Typography>
        </section>
      </div>
    </div>
  );
};
